// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular.json`.

export const environment = {
    production: true,
    apiUrl: 'https://app.labo-mylab.fr/',
    uploadFolderUrl: 'https://app.labo-mylab.fr/uploads/',
    cancellableDus: ['LIPO_IR', 'DM_BACTO', 'FAM_30_LAIT'],
    publicSiteBypassKey: 'dd394644-ab11-4224-916e-39c31ad5bafa',
    dairyRoles: ['LAITE', 'TECHLAITE'],
    clientsNotAllowedToOrderAnalysis: ['TECHLAITE'],
    productClasses: ['EAUX', 'COSMETIQUES', 'AGRONOMIE', 'DIVERS', 'PRODUITS LAITIERS']
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts